import React from 'react';
import {
    Box,
    Typography,
} from '@mui/material';
import {
    Add as AddIcon,
    FavoriteBorder as FavoriteBorderIcon,
    ChatBubbleOutline as ChatBubbleOutlineIcon,
    Share as ShareIcon,
    MusicNote as MusicNoteIcon,
    Check as CheckIcon
} from '@mui/icons-material';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TikTok = ({ selectedAccounts, formattedTags, accResp, selectedImages, selectedIndex, avatars, postTitle, postText }) => {
    return (
        <Box maxWidth="sm" className="containerTiktok mt-6">
            <Box className="video-container" position="relative" borderRadius={2} overflow="hidden">

                {selectedImages.length > 0 && (
                    <Box className="flex justify-center">
                        <Box style={{ width: '100%', height: '100%' }}>
                            <Slider
                                dots={false}
                                infinite={false}
                                speed={500}
                                slidesToShow={1}
                                slidesToScroll={1}
                                arrows={false}
                                className="slider"
                            >
                                {selectedImages.map((image, i) => (
                                    <Box key={i} style={{ width: '100%', height: '100%' }}>
                                        <img src={image.props.src} alt="Preview" style={{ width: '100%', height: '100%' }} />
                                    </Box>
                                ))}
                            </Slider>
                        </Box>
                    </Box>
                )}

                <Box className="side-barTiktok">

                    {selectedAccounts.length === 0 ? (
                        <Box className="side-icon profile-follow" display="flex" alignItems="center">
                            <Box className="avatar" sx={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '50%',
                                backgroundColor: 'var(--background-preview)',
                            }}/>
                            <AddIcon className="fa-plus" sx={{ color: '#fff' }} />
                        </Box>
                    ) : (
                        <>
                            {selectedAccounts.map((id, i) => {
                                const index = accResp.findIndex((acc) => acc.id === id);
                                const avatar = avatars[index];

                                return (
                                    <Box key={id} className="side-icon profile-follow" display="flex" alignItems="center">
                                        <img
                                            src={avatar}
                                            alt=""
                                            className="profile-logo-img"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                const placeholder = document.createElement('div');
                                                placeholder.style.cssText = 'width:50px;height:50px;display:flex;align-items:center;' +
                                                  'justify-content:center;color:white;font-weight:bold;font-size:20px;' +
                                                  'border-radius:50%;background:#ff0050';
                                                const userName = accResp[accResp.findIndex((acc) => acc.id === id)].username;
                                                placeholder.textContent = userName.charAt(0).toUpperCase();
                                                e.target.parentElement.appendChild(placeholder);
                                            }}
                                        />
                                        <AddIcon className="fa-plus" sx={{ color: '#fff' }} />
                                    </Box>
                                );
                            })}
                        </>
                    )}
                    <Box className="side-icon like-btn" display="flex" alignItems="center">
                        <FavoriteBorderIcon sx={{ color: 'red' }} />
                        <Typography className="like-number">789</Typography>
                    </Box>
                    <Box className="side-icon comment-btn" display="flex" alignItems="center">
                        <ChatBubbleOutlineIcon sx={{ color: '#fff' }} />
                        <Typography className="comment-number">184</Typography>
                    </Box>
                    <Box className="side-icon share-btn" display="flex" alignItems="center">
                        <ShareIcon sx={{ color: '#fff' }} />
                        <Typography className="share-number">10</Typography>
                    </Box>
                </Box>

                <Box className="post-footer" mt={2}>
                    <Box className="username verfied">
                        <Box>
                            {selectedAccounts.length === 0 ? (
                                <Box sx={{ width: '120px', height: '15px', backgroundColor: '#4f4f4f' }}>
                                    <Typography component="div" sx={{
                                        width: '100%',
                                    }} />
                                </Box>
                            ) : (
                                <>
                                    {selectedAccounts.map((id, i) => {
                                        const index = accResp.findIndex((acc) => acc.id === id);
                                        const userName = accResp[index].username;

                                        return (
                                            <Typography component="span" className="username-link">{userName}</Typography>
                                        );
                                    })}
                                </>
                            )}
                        </Box>
                        <CheckIcon className="verfied-icon" />
                    </Box>
                    {postText === undefined || postText === '' ? (
                        <Box className="post-description">
                            <Box sx={{ width: '100%', display: "block", alignSelf: 'center' }}>
                                <Box style={{
                                    width: '100%',
                                    height: '12px',
                                    backgroundColor: 'var(--background-preview)',
                                    marginBottom: '5px'
                                }}></Box>
                                <Box style={{
                                    width: '70%',
                                    height: '12px',
                                    backgroundColor: 'var(--background-preview)',
                                    marginBottom: '5px'
                                }}></Box>
                                <Box style={{
                                    width: '50%',
                                    height: '12px',
                                    backgroundColor: 'var(--background-preview)',
                                    marginBottom: '5px'
                                }}></Box>
                            </Box>
                        </Box>
                    ) : (
                        <>
                            <Typography component="div"
                                style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    marginBottom: '5px',
                                    color: 'var(--text-color)'
                                }}>
                                {postText}
                            </Typography>
                            <Typography component="div"
                                style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    marginBottom: '5px',
                                    color: 'var(--text-color)'
                                }}>
                                {formattedTags}
                            </Typography>
                        </>
                    )}

                    <Box className="music-name" display="flex" alignItems="center" mt={1}>
                        <MusicNoteIcon/>
                        <div className="marquee">
                            <div className="marquee-content">
                                Tungevaag, Raaban - Bad Boy
                            </div>
                        </div>
                    </Box>
                </Box>

                <Box className="disc-logo">
                    <img
                        src="https://www.nicepng.com/png/detail/329-3297274_compact-disc-cd-comments-disc-icon-png.png"
                        alt=""
                        className="disc-logo-img"
                        style={{ width: '50px', height: 'auto' }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default TikTok;
